import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { HttpService } from "./http-service";
import { ToastrService } from "ngx-toastr";
import { HttpClient} from '@angular/common/http';
import * as CryptoJS from "crypto-js";
import { environment } from "src/enviroment";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class UsuarioService extends HttpService {
 constructor(
     http: HttpClient,
     router: Router,
     toastService: ToastrService,
     @Inject(PLATFORM_ID) platformId: Object
   ) {
     super(http, router, toastService, platformId);
   }

  generateHash(obj: string, salt: string): string {
    const jsonString = JSON.stringify(obj);
    const key = CryptoJS.enc.Utf8.parse(environment.version);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(jsonString, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encryptedStr = CryptoJS.enc.Base64.stringify(
      iv.concat(encrypted.ciphertext)
    );
    return encryptedStr;
  }

  getInfoPageHtml(id, callback) {
    this.get("usuario/infoPageHtml/" + id, callback);
  }

  cidadesPorUf(uf, callback) {
    this.get("usuario/cidadesPorUf/" + uf, callback);
  }

  cadastraCliente(registro: boolean, form, callback, callbackError) {
    if (registro) {
      this.post("principal/cadastraCliente", form, callback, callbackError);
    } else {
      this.post("usuario/cadastraCliente", form, callback, callbackError);
    }
  }

  cadastraClienteInterno(form, callback, callbackError) {
    this.post("cadastro/cadastraClienteInterno", form, callback, callbackError);
  }
  
  ativaCliente(form, callback, callbackError) {
    this.post(`usuario/ativar`, form, callback, callbackError);
  }
  
  getClienteValido(hash, callback, callbackError) {
    this.get(`usuario/ativar?hash=${hash}`, callback, callbackError);
  }

  cadastraRepresentante(registro: boolean, form, callback, callbackError) {
    let [dia, mes, ano] = form.nascimento.split("/");
    form.nascimento = `${ano}-${mes}-${dia}`;
    this.post("principal/cadastraFuncionarios", form, callback, callbackError);
  }

  listaRepresentante(form, callback, callbackError) {
    let tipo = "R";
    let nome = form.nome === "" ? "" : "&nome=" + form.nome;
    let documento = form.documento === "" ? "" : "&documento=" + form.documento;
    let status = form.status === "asdas" ? "" : "&status=" + form.status;
    let page = "&page=" + form.page;
    this.get(
      `cadastro/listaFuncionarios?tipo=${
        tipo + status + nome + documento + page
      }`,
      callback,
      callbackError
    );
  }
  listaCliente(form, callback, callbackError) {
    let tipo = "R";
    let nome = form.nome === "" ? "" : "&nome=" + form.nome;
    let documento = form.documento === "" ? "" : "&documento=" + form.documento;
    let status = form.status === "asdas" ? "" : "&status=" + form.status;
    let page = "&page=" + form.page;
    this.get(
      `cadastro/listaClientes?tipo=${tipo + status + nome + documento + page}`,
      callback,
      callbackError
    );
  }

  aprovaRepresentante(form, callback, callbackError) {
    this.post(`cadastro/aprovaFuncionarios`, form, callback, callbackError);
  }

  getRepresentante(id, callback, callbackError) {
    this.get(
      `cadastro/detalhaFuncionarios?funcionario=${id}`,
      callback,
      callbackError
    );
  }

  getEstoque(form, callback, callbackError) {
    let filial = form.filial === "" ? "" : "&filial=" + form.filial;
    let sku = form.sku === "" ? "" : "&sku=" + form.sku;
    this.get(
      `historico/estoque?pagina=${form.page}${filial}${sku}&tipo=${form.tipo}`,
      callback,
      callbackError
    );
  }

  getPreco(form, callback, callbackError) {
    let produto = form.produto === "" ? "" : "&produto=" + form.produto;
    let tabela = form.tabela === "" ? "" : "&tabela=" + form.tabela;
    this.get(
      `historico/preco?pagina=${form.page}${produto}${tabela}`,
      callback,
      callbackError
    );
  }

  listaVendas(form, callback, callbackError) {
    let dataI = form.dataI === "" ? "" : "&data_emissao_inicial=" + form.dataI;
    let dataF = form.dataF === "" ? "" : "&data_emissao_final=" + form.dataF;
    this.get(
      `historico/vendasPorPedido?pagina=1&qtdporpagina=5${
        dataI + dataF
      }&page=0`,
      callback,
      callbackError
    );
  }

  getCliente(id, callback, callbackError) {
    this.get(
      `cadastro/detalhaClientes?funcionario=${id}`,
      callback,
      callbackError
    );
  }

  getPix(form, callback, callbackError) {
    this.get(
      `integracao/cadastraPix?pedido_cliente=${form.pedido_cliente}`,
      callback,
      callbackError
    );
  }
getCep(cep, callback, callbackError) {
  this.get2(
    `https://viacep.com.br/ws/${cep.replace("-", "")}/json/`,
    (response) => {
      if (response.erro) {
        if (callbackError) callbackError("CEP não encontrado");
      } else {
        callback(response.cep); // aqui pega só o valor do CEP
      }
    },
    callbackError
  );
}
  consultaPix(form, callback, callbackError) {
    this.get(
      `integracao/consultaPix?pedido_cliente=${form.pedido_cliente}`,
      callback,
      callbackError
    );
    
  }

  getUsuarios(busca, callback) {
    this.post("usuario/getUsuarios", { busca: busca }, callback);
  }

  
  getClientes(busca, callback) {
    this.post("usuario/getBuscaCliente", { busca: busca.busca }, callback);
  }

  getClientesId(busca, callback) {
    this.get(`usuario/getClienteID/${busca.id_cliente}`, callback);
  }

  getTipoPagamento(id_cliente, callback) {
    this.get(`usuario/getTipoPagamento/${id_cliente}`, callback);
  }

  getTabelas(id, callback, filial: string | number = "") {
    const clienteId = id !== 100 ? "?cliente_id=" + id : "";
    const filialParam =
      filial === "" || filial === null || filial === undefined
        ? ""
        : "&filial=" + encodeURIComponent(String(filial));
    this.get(`usuario/getTabelas` + clienteId + filialParam, callback);
  }

  getPedidoTipos(callback) {
    this.get("usuario/getPedidoTipos", callback);
  }

  getPedidoData(endpoint, data, callback, callbackError?) {
    const params = new URLSearchParams(data).toString();
    this.get(`${endpoint}?${params}`, callback, callbackError);
  }
  
  getBoletos(data, callback, callbackError?) {
    this.getPedidoData('usuario/getBoletos', data, callback, callbackError);
  }

  boleto(id, callback) {
    this.post("usuario/boleto", { id: id }, callback);
  }

  getFiliais(id, callback) {
    this.get(`usuario/getFiliais`, callback);
  }

  /**
   * Altera a senha do usuário logado
   * @param senhaAntiga Senha antiga
   * @param senhaNova Senha nova
   * @param callback Retorno caso sucesso
   * @param callbackError Retorno caso falha
   */
  updatePassword(senhaAntiga, senhaNova, callback, callbackError) {
    let obj = { senhaAntiga: senhaAntiga, senhaNova: senhaNova };
    let cripto = this.generateHash(JSON.stringify(obj), environment.version);
    this.post(
      "usuario/updatesenha",
      { dados: cripto },
      callback,
      callbackError
    );
  }
}
